"use client";

import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";
import { fetchMenus } from "../../../features/rbac/rbacSlice";

const HorizontalNavbar = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { menus, loading } = useAppSelector((state) => state.rbac);

  const isActiveLink = (path) => (location.pathname === path ? "active" : "");

  useEffect(() => {
    dispatch(fetchMenus());
  }, [dispatch]);

  return (
    <>
      <div className="horizontal-navbar-area">
        <div className="accordion">

          {/* Dashboard — always visible */}
          <div className="accordion-item megamenu">
            <Button
              component={Link}
              to="/"
              type="button"
              className={`accordion-button ${isActiveLink("/")}`}
            >
              <i className="material-symbols-outlined">dashboard</i>
              <span className="title" style={{ lineHeight: 1 }}>
                Dashboard
              </span>
            </Button>
          </div>

          {/* Dynamic menus from RBAC */}
          {!loading &&
            menus.map((menu) => {
              /* Direct-link menu (has route, no sub-pages) */
              if (menu.route && (!menu.pages || menu.pages.length === 0)) {
                return (
                  <div key={menu._id} className="accordion-item megamenu">
                    <Button
                      component={Link}
                      to={menu.route}
                      type="button"
                      className={`accordion-button ${isActiveLink(menu.route)}`}
                    >
                      <i className="material-symbols-outlined">{menu.icon}</i>
                      <span className="title" style={{ lineHeight: 1 }}>
                        {menu.name}
                      </span>
                    </Button>
                  </div>
                );
              }

              /* Accordion menu (has sub-pages) */
              if (!menu.pages?.length) return null;
              const visiblePages = menu.pages.filter((p) => !p.hide);
              if (!visiblePages.length) return null;

              return (
                <div key={menu._id} className="accordion-item megamenu">
                  <Button type="button" className="accordion-button">
                    <i className="material-symbols-outlined">{menu.icon}</i>
                    <span className="title" style={{ lineHeight: 1 }}>
                      {menu.name}
                    </span>
                  </Button>
                  <div className="accordion-body border-radius">
                    <ul className="sidebar-sub-menu">
                      {visiblePages.map((page) => (
                        <li key={page.key} className="sidemenu-item">
                          <Link
                            to={page.route}
                            className={`sidemenu-link border-radius ${isActiveLink(
                              page.route
                            )}`}
                          >
                            {page.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })}

        </div>
      </div>
    </>
  );
};

export default HorizontalNavbar;
